import React, { useState } from 'react'
import styles from '../../styles/Register.module.scss'
import { useTranslation } from 'react-i18next'

import {
	Row,
	Col,
	Button,
	Card
} from 'react-bootstrap'

import CardBodyComponent from '../CardBodyComponent'
import EducationModal from '../EducationModal'

export default function Education({ setCurrentStep, educationEnums, educations, setEducations, educationIds, setEducationIds }): JSX.Element {
	const [show, setShow] = useState(false)
	const { t } = useTranslation()
	return (
		<div>
			<Row className={styles.row}>
				<Col className='pull-right'>
					<Button
						className='text-white'
						onClick={() => setShow(true)}
					>
						{t('update_profile.add_education')}
					</Button>
				</Col>
			</Row>
			<Card>
				<Card.Header>{t('profile_new.education')}</Card.Header>
				{educations.length === 0 && (
					<Card.Body className={styles.experincesCard}>
						<p className='text-black'>
							{t('update_profile.no_edu_added')}
						</p>
						<p>
							{t('update_profile.add_edu_to_increase_chances')}
						</p>
					</Card.Body>
				)}
				{educations.length > 0 && (
					<CardBodyComponent
						educations={educations}
						setEducations={setEducations}
						educationIds={educationIds}
						setEducationIds={setEducationIds}
					/>
				)}
			</Card>

			<EducationModal
				show={show}
				setShow={setShow}
				educations={educations}
				setEducations={setEducations}
				educationEnums={educationEnums}
			/>

			<hr className='mt-4 mb-4' />

			<Row>
				<Col>
					<Button
						variant='link'
						className='text-black'
						onClick={() => setCurrentStep(2)}
					>
						{t('update_profile.back')}
					</Button>
				</Col>
				<Col className='pull-right'>
					<Button variant='link' onClick={() => setCurrentStep(4)}>{t('update_profile.skip_now')}</Button>
					<Button
						onClick={() => setCurrentStep(4)}
						className='text-white'
					>
						{t('update_profile.next_step')}
					</Button>
				</Col>
			</Row>
		</div>
	)
}
